import * as React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import s from './Navbar.module.scss';
import Reveal from '~components/swace/reveal';
import Hamburger from '~components/shared/Hamburger';
import { getDevice } from '~libs/utils';
import { DynamicLink } from '~components/shared/components';
import { Menu } from '~types';
import NavbarMenuGroup from './NavbarMenuGroup';
import LogoImage from '../../img/zound_logo.png';

interface Props {}

class Navbar extends React.Component<Props> {
  hamburgerRef?: Hamburger;

  closeHamburger = () => {
    if (this.hamburgerRef) {
      this.hamburgerRef.close();
    }
  };

  render() {
    const isIOS = getDevice() === 'ios';

    return (
      <StaticQuery
        query={QUERY}
        render={data => {
          const {
            logotype_header,
            logotype_header_dark,
          } = data.wordpressAcfOptions.options;

          const { url: baseUrl } = data.wordpressSiteMetadata;

          const menus: Menu[] = data.allWordpressWpApiMenusMenusItems.edges;

          const contactMenu = menus.find(edge =>
            edge.node.slug.includes('contact')
          );

          return (
            <Reveal fade>
              <Hamburger
                ref={r => {
                  this.hamburgerRef = r;
                }}
                logo={{
                  top: (
                    <DynamicLink to="/" onClick={this.closeHamburger}>
                      <Img
                        className={`${s.logotype} ${s.top}`}
                        fluid={logotype_header.localFile.childImageSharp.fluid}
                      />
                    </DynamicLink>
                  ),
                  topOpen: (
                    <DynamicLink to="/" onClick={this.closeHamburger}>
                      <Img
                        className={`${s.logotype} ${s.top}`}
                        fluid={logotype_header.localFile.childImageSharp.fluid}
                      />
                    </DynamicLink>
                  ),
                  fixed: (
                    <DynamicLink to="/" onClick={this.closeHamburger}>
                      <img
                        src={LogoImage}
                        alt="Zound logo"
                        className={`${s.logotype} ${s.img}`}
                      />
                    </DynamicLink>
                  ),
                }}
              >
                <div className={s.wrapper}>
                  <div className="container-fluid">
                    <div className="row">
                      {/*
                        Right side menu with blue background
                      */}
                      <div
                        className={`col-12 col-md-5 col-lg-4 h-100 ${s.rightMenuContainer}`}
                      >
                        <div className={[s.menuWrapper, s.blue].join(' ')}>
                          <div
                            className={[
                              s.scrollWrapper,
                              isIOS ? s.ios : null,
                            ].join(' ')}
                          >
                            <div className={s.menu}>
                              {menus &&
                                menus
                                  .filter(
                                    edge =>
                                      edge.node.slug.includes('about') ||
                                      edge.node.slug.includes('brands')
                                  )
                                  .map(edge => (
                                    <NavbarMenuGroup
                                      key={edge.node.slug}
                                      menuItems={edge.node.items}
                                      menuTitle={edge.node.name}
                                      baseUrl={baseUrl}
                                      large
                                      onClick={this.closeHamburger}
                                    />
                                  ))}
                              <NavbarMenuGroup
                                menuItems={contactMenu.node.items}
                                menuTitle={contactMenu.node.name}
                                baseUrl={baseUrl}
                                hiddenDesktop
                                large
                                onClick={this.closeHamburger}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Hamburger>
            </Reveal>
          );
        }}
      />
    );
  }
}

const QUERY = graphql`
  query {
    allWordpressWpNews(limit: 1) {
      edges {
        node {
          slug
          acf {
            title
            previewImage: preview_image {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressWpApiMenusMenusItems {
      edges {
        node {
          name
          slug
          items {
            order
            title
            url
          }
        }
      }
    }
    wordpressSiteMetadata {
      url
    }
    wordpressAcfOptions {
      options {
        logotype_header {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
        logotype_header_dark {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
        logotype_footer {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  }
`;

export default Navbar;
